import { useCallback, useState } from 'react';
import { getToken } from '../utils/auth';

// Same direct-fetch pattern as useManualUpload - FormData uploads can't go
// through baseQuery (it always forces application/json headers).
export const useAsrComparison = () => {
  const [state, setState] = useState({ isLoading: false, error: null, result: null });

  const compare = useCallback(async ({ audioFile, campaignName }) => {
    setState({ isLoading: true, error: null, result: null });

    try {
      const formData = new FormData();
      formData.append('audio', audioFile);
      if (campaignName) formData.append('campaignName', campaignName);

      const base = process.env.REACT_APP_API_BASE || '';
      const token = getToken();

      const response = await fetch(`${base}/api/asr-comparison`, {
        method: 'POST',
        headers: token ? { Authorization: `Bearer ${token}` } : {},
        body: formData,
      });

      const body = await response.json().catch(() => ({}));

      if (!response.ok || body?.success === false) {
        throw new Error(body?.error?.message || 'Comparison failed');
      }

      setState({ isLoading: false, error: null, result: body.data });
      return body.data;
    } catch (err) {
      setState({ isLoading: false, error: err.message, result: null });
      throw err;
    }
  }, []);

  return { state, compare };
};
